/**
 * Search Analytics Beacon
 *
 * Collects search events and sends them in batches to the analytics API.
 * Uses sendBeacon on page hide for reliable delivery.
 *
 * Usage: window.searchAnalytics.track(eventType, data)
 */
(function () {
  'use strict';

  // Configuration from theme settings (injected via data attributes on <script>)
  var scriptTag = document.currentScript;
  var apiEndpoint = scriptTag ? scriptTag.getAttribute('data-api-endpoint') : null;
  var apiKey = scriptTag ? scriptTag.getAttribute('data-api-key') : null;

  if (!apiEndpoint || !apiKey) {
    console.warn('[SearchAnalytics] Missing API endpoint or key. Beacon disabled.');
    return;
  }

  // Session ID (per browser tab session)
  var SESSION_KEY = 'search_analytics_session';
  var sessionId = sessionStorage.getItem(SESSION_KEY);
  if (!sessionId) {
    sessionId = 'sess_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem(SESSION_KEY, sessionId);
  }

  // Detect locale from URL
  var locale = window.location.pathname.startsWith('/ar') ? 'ar' : 'en';

  // Event queue
  var queue = [];
  var FLUSH_INTERVAL = 5000; // 5 seconds
  var MAX_QUEUE_SIZE = 20;

  function flush() {
    if (queue.length === 0) return;

    var events = queue.splice(0, queue.length);
    var payload = JSON.stringify({
      apiKey: apiKey,
      shop: window.Shopify && window.Shopify.shop ? window.Shopify.shop : undefined,
      events: events,
    });

    // Try sendBeacon first (most reliable for page unload)
    if (navigator.sendBeacon) {
      var sent = navigator.sendBeacon(apiEndpoint, payload);
      if (sent) return;
    }

    // Fallback to fetch with keepalive
    try {
      fetch(apiEndpoint, {
        method: 'POST',
        body: payload,
        headers: { 'Content-Type': 'text/plain' },
        keepalive: true,
      }).catch(function () {
        // Silent fail - analytics should never break the site
      });
    } catch (e) {
      // Silent fail
    }
  }

  // Periodic flush
  var flushTimer = setInterval(flush, FLUSH_INTERVAL);

  // Flush on page hide (reliable across browsers)
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') {
      flush();
    }
  });

  // Flush on page unload (backup)
  window.addEventListener('pagehide', flush);

  /**
   * Track a search analytics event.
   * @param {string} eventType - One of: search_submitted, search_results_shown, search_result_click, image_search_used, image_search_results, voice_search_used
   * @param {object} data - Event-specific data
   */
  function track(eventType, data) {
    if (!eventType) return;

    var event = {
      eventType: eventType,
      sessionId: sessionId,
      locale: locale,
      searchTerm: data.search_term || data.searchTerm || undefined,
      resultCount: data.result_count != null ? data.result_count : data.search_results != null ? data.search_results : data.resultCount != null ? data.resultCount : undefined,
      resultProductIds: data.result_product_ids || data.resultProductIds || undefined,
      searchFilter: data.search_filter || data.searchFilter || undefined,
      clickedProductId: data.product_id || data.clickedProductId || undefined,
      clickedResultType: data.result_type || data.clickedResultType || undefined,
      clickedPosition: data.position != null ? data.position : data.clickedPosition != null ? data.clickedPosition : undefined,
      clickedUrl: data.result_url || data.clickedUrl || undefined,
      imageFileType: data.file_type || data.imageFileType || undefined,
      imageFileSize: data.file_size != null ? data.file_size : data.imageFileSize != null ? data.imageFileSize : undefined,
      imageResultIds: data.ids ? (Array.isArray(data.ids) ? data.ids.join(',') : String(data.ids)) : data.imageResultIds || undefined,
      voiceMethod: data.voice_search_method || data.voiceMethod || undefined,
      voiceSuccess: data.voice_search_success != null ? data.voice_search_success : data.voiceSuccess != null ? data.voiceSuccess : undefined,
    };

    // Remove undefined values
    Object.keys(event).forEach(function (key) {
      if (event[key] === undefined) delete event[key];
    });

    queue.push(event);

    // Flush if queue is full
    if (queue.length >= MAX_QUEUE_SIZE) {
      flush();
    }
  }

  // Expose public API
  window.searchAnalytics = { track: track };
})();
